import { Stack } from '@mui/material';
import React from 'react';
import { formatCurrency } from '../../../../../services/ApiService';
import DollarInput, { convertMask } from '../../../../../components/Masks/DollarInput';
import RupiahInput, { convertMaskIDR } from '../../../../../components/Masks/RupiahInput';

import ButtonComponent from '../../../../../components/Buttons/ButtonComponent';
import { Input, showToast } from '../../../../../components/ui';
import { convertToNominal } from '../../../../../utils/masks';

const TabCash = (props) => {
    const countTotalPaymentIDR = () => {
        if (props.checkSelectedInvoice.id !== undefined) {
            // if (props.checkMethod(props.InvoiceList) !== 2) {
                let amountUSD = 0;
                let amountIDR = 0;

                if (formatCurrency === 'USD') {
                    amountUSD = parseFloat(convertMask(props.CashPaymentUSD));
                    amountIDR = parseFloat(convertMask(props.CashPaymentIDR));
                }
                else {
                    amountUSD = parseFloat(convertMaskIDR(props.CashPaymentUSD));
                    amountIDR = parseFloat(convertMaskIDR(props.CashPaymentIDR));
                }

                if (amountUSD < 0) {
                    showToast({ type: 'error', message: 'Please Input Cash Payment USD!' });
                }
                else if (amountIDR < 0) {
                    showToast({ type: 'error', message: 'Please Input Cash Payment IDR!' });
                }
                else {
                    let count = 0;
                    const newArray = props.InvoiceList.slice();
                    newArray.forEach(el => {
                        if (el.invoiceId === props.checkSelectedInvoice.invoiceId) {
                            el.totalCashUSD = parseFloat(amountUSD);
                            el.totalCashIDR = parseFloat(amountIDR);
                        }
                    });
                    props.setInvoiceList(newArray);

                    props.calculateTotalCash(newArray);
                    props.calculateTotalDifferent(newArray);

                    count = (parseFloat(amountUSD) * parseFloat(props.RateCount)) + parseFloat(amountIDR);
                    let formatInIDR = convertToNominal(count);

                    props.setTotalCashPaymentIDR(formatInIDR);
                    showToast({ type: 'success', message: 'Cash Added Successfully!' });
                }
            // }
            // else {
            //     showToast({ type: 'error', message: 'Please Input Payment Method on Bank Only!' });
            // }
        }
        else {
            showToast({ type: 'error', message: 'Please Select Invoice First!' });
        }
    };

    return (
        <>
            <Stack spacing={'32px'} direction="row">
                <Input
                    label='Cash Payment USD'
                    textAlign='right'
                    value={props.CashPaymentUSD}
                    onChange={(e) => props.setCashPaymentUSD(formatCurrency === 'USD' ? convertMask(e.target.value, 1) : convertMaskIDR(e.target.value, 1))}
                    formControlProps={{
                        sx: {
                            width: '100%'
                        }
                    }}
                    inputBaseProps={{
                        inputComponent: formatCurrency === 'USD' ? DollarInput : RupiahInput,
                    }}
                    disabled={props.Printing > 0}
                />

                <Input
                    label='Cash Payment IDR'
                    textAlign='right'
                    value={props.CashPaymentIDR}
                    onChange={(e) => props.setCashPaymentIDR(formatCurrency === 'USD' ? convertMask(e.target.value, 1) : convertMaskIDR(e.target.value, 1))}
                    formControlProps={{
                        sx: {
                            width: '100%'
                        }
                    }}
                    inputBaseProps={{
                        inputComponent: formatCurrency === 'USD' ? DollarInput : RupiahInput,
                    }}
                    disabled={props.Printing > 0}
                />

                <Input
                    label='Cash Payment In IDR'
                    textAlign='right'
                    value={props.TotalCashPaymentIDR}
                    disabled
                    formControlProps={{
                        sx: {
                            width: '100%'
                        }
                    }}
                    inputBaseProps={{
                        inputComponent: formatCurrency === 'USD' ? DollarInput : RupiahInput,
                    }}
                />
            </Stack>

            <div style={{ marginTop: '16px', marginLeft: '-12px' }}>
                {ButtonComponent.AddButton(countTotalPaymentIDR, '', (props.Printing > 0 ? true : false))}
            </div>
        </>
    )
}

export default TabCash;